/**
 * Stats counter animation.
 *
 * For each `.split-content-stats__grid` block, when the grid scrolls into view
 * all child `[data-stat-value]` elements count up from 0 to their target value.
 * Animation runs once per page load (IntersectionObserver disconnects after firing).
 *
 * The value is a raw string such as "50%", "$1.2M", "~2x", or "Top 10".
 * The first number found in the string is animated; surrounding non-numeric
 * characters are kept static. If no number is present the element is left as-is.
 *
 * Respects prefers-reduced-motion — skips animation and shows final value immediately.
 */

(function () {
    var DURATION = 1600; // ms
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /**
     * Easing: ease-out cubic
     * @param {number} t - progress 0..1
     * @returns {number}
     */
    function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
    }

    /**
     * Animate a single value element from 0 to its target.
     * @param {HTMLElement} el
     */
    function animateStat(el) {
        var raw = el.dataset.statValue || '';

        // Extract: anything before the number, the number itself, anything after.
        var match = raw.match(/^(.*?)(\d+(?:\.\d+)?)(.*)$/);
        if (!match) return; // no numeric portion — nothing to animate

        var before = match[1];
        var numStr = match[2];
        var after = match[3];
        var target = parseFloat(numStr);
        var decimals = numStr.indexOf('.') !== -1 ? numStr.split('.')[1].length : 0;

        if (isNaN(target) || prefersReducedMotion) return;

        var start = null;

        function step(timestamp) {
            if (!start) start = timestamp;
            var elapsed = timestamp - start;
            var progress = Math.min(elapsed / DURATION, 1);
            var eased = easeOutCubic(progress);
            var current = eased * target;
            el.textContent = before + current.toFixed(decimals) + after;
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = raw; // restore original string exactly
            }
        }

        requestAnimationFrame(step);
    }

    /**
     * Set up an IntersectionObserver for each stats grid.
     */
    function init() {
        var grids = document.querySelectorAll('.split-content-stats__grid');
        if (!grids.length) return;

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                entry.target.querySelectorAll('[data-stat-value]').forEach(animateStat);
            });
        }, { threshold: 0.25 });

        grids.forEach(function (grid) {
            observer.observe(grid);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
